import { render } from "./ChildAccountEdit.vue?vue&type=template&id=a3b6db04&ts=true"
import script from "./ChildAccountEdit.vue?vue&type=script&lang=ts"
export * from "./ChildAccountEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__